// extracted by mini-css-extract-plugin
module.exports = {"b2ep0qa":"b2ep0qa","boxSpin-b2ep0qa":"boxSpin-b2ep0qa"};